import React, { useState } from "react";

import Icon from "../Icon";

import * as styles from "./FloatingThingy.module.css";

const FloatingThingy = ({ children, variant }) => {
  const [floatingThingyActive, setFloatingThingyActive] = useState(
    variant === "panel" ? true : false
  );

  const DefaultPanel = () => {
    return (
      <div className={`${styles.floatingThingy}`}>
        {floatingThingyActive ? (
          <div className={styles.panel}>
            <span className={styles.close}>
              <button
                aria-label="close"
                onClick={() => setFloatingThingyActive(false)}
              >
                <Icon
                  props={{
                    name: "fa-times",
                    type: "solid",
                    size: "lg",
                    color: "black",
                  }}
                />
              </button>
            </span>
            {children && children}
          </div>
        ) : (
          <div className={`${styles.dot}`}>
            <button
              aria-label="Let's Get You Thriving"
              onClick={() => setFloatingThingyActive(true)}
            >
              <Icon
                props={{
                  name: "fa-comment",
                  type: "regular",
                  size: "2x",
                  color: "darkBlue",
                }}
              />
            </button>
          </div>
        )}
      </div>
    );
  };

  const VariantPanel = () => {
    return (
      <div className={`${styles.floatingThingy} ${styles.panelVariant}`}>
        <div
          className={`${styles.panel} ${
            floatingThingyActive ? styles.open : styles.closed
          }`}
        >
          <div>{children && children}</div>
          <span className={styles.close}>
            {floatingThingyActive ? (
              <button
                aria-label="close"
                onClick={() => setFloatingThingyActive(false)}
              >
                <Icon
                  props={{
                    name: "fa-chevron-down",
                    type: "solid",
                    size: "lg",
                    color: "black",
                  }}
                />
              </button>
            ) : (
              <button
                aria-label="close"
                onClick={() => setFloatingThingyActive(true)}
              >
                <Icon
                  props={{
                    name: "fa-chevron-up",
                    type: "solid",
                    size: "lg",
                    color: "black",
                  }}
                />
              </button>
            )}
          </span>
        </div>
      </div>
    );
  };

  return variant === "panel" ? <VariantPanel /> : <DefaultPanel />;
};

export default FloatingThingy;
